import { SignedImg } from "@/components/shared/SignedImg";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff, Lock, Maximize2, Pencil, Send, Trash2 } from "lucide-react";
import { formatDate } from "@/lib/format";
import { canRedate } from "@/components/gallery/GalleryGrid";

const LOCK_SRC = { attendance: "z docházky", daysheet: "z výkazu", task: "z úkolu" };

// Pravý panel (desktop) / obsah spodního sheetu (mobil): náhled + metadata + akce.
export function GalleryDetailPanel({ photo, canEye, canDelete, onEye, onZoom, onSend, onDelete, onRedateTap }) {
  if (!photo) return <div className="text-sm text-muted-foreground p-4" data-testid="gallery-detail-empty">Vyber fotku vlevo.</div>;
  const inDiary = photo.status === "approved";
  return (
    <div className="space-y-3" data-testid="gallery-detail">
      <button type="button" onClick={() => onZoom(photo)} data-testid="detail-preview"
        className="block w-full rounded-[12px] overflow-hidden border border-border bg-secondary cursor-zoom-in">
        <SignedImg url={photo.url} alt={photo.caption} thumb={300} className="w-full max-h-[280px] object-contain" />
      </button>
      <div className="text-sm space-y-1">
        {photo.caption && <div className="font-semibold">{photo.caption}</div>}
        <div className="text-muted-foreground">{photo.project_name || "—"}</div>
        <div className="text-muted-foreground">{formatDate(photo.date)} · {photo.author_name} · {photo.source_label}</div>
        <div className="pt-1">
          {canRedate(photo) ? (
            <button type="button" data-testid="detail-date-editable" onClick={() => onRedateTap?.(photo)}
              className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-brand/10 text-brand">
              <Pencil size={12} /> Datum lze změnit
            </button>
          ) : (
            <span data-testid="detail-date-locked"
              className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-secondary text-muted-foreground">
              <Lock size={12} /> Datum {LOCK_SRC[photo.source] || "z docházky"} — nelze měnit
            </span>
          )}
        </div>
      </div>
      {canEye && inDiary && (
        <div className="space-y-1" data-testid="detail-diary-state">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full bg-brand text-white text-sm font-bold" data-testid="detail-eye-state">
              <Eye size={15} /> V deníku
            </span>
            <Button variant="outline" size="sm" className="rounded-full" onClick={() => onEye(photo)} data-testid="detail-eye">
              <EyeOff size={15} className="mr-1" /> Skrýt z deníku
            </Button>
          </div>
          <div className="text-xs text-muted-foreground" data-testid="detail-diary-since">
            V deníku od {formatDate(photo.approved_at)}{photo.approved_by_name ? ` · ${photo.approved_by_name}` : ""}
          </div>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {canEye && !inDiary && (
          <Button variant="outline" className="rounded-full" onClick={() => onEye(photo)} data-testid="detail-eye">
            <Eye size={15} className="mr-1" /> Zobrazit v deníku
          </Button>
        )}
        <Button variant="outline" className="rounded-full" onClick={() => onZoom(photo)} data-testid="detail-zoom"><Maximize2 size={15} className="mr-1" /> Zvětšit</Button>
        <Button variant="outline" className="rounded-full" onClick={() => onSend(photo)} data-testid="detail-send"><Send size={15} className="mr-1" /> Poslat</Button>
        {canDelete && (
          <Button variant="ghost" className="rounded-full text-muted-foreground" onClick={() => onDelete(photo)} data-testid="detail-delete"><Trash2 size={15} className="mr-1" /> Smazat fotku</Button>
        )}
      </div>
    </div>
  );
}
